import { apiBase } from './site-config';

export async function loadCollection() {
  const response = await fetch(`${apiBase}/products`);
  return response.json();
}

export async function loadPlaces() {
  const response = await fetch(`${apiBase}/stores`);
  return response.json();
}
